<template>
  <div>
    <ItemNews
      :news="item"
      v-for="item in listNews"
      :key="item.id"
      class="mb-6"
    />
    <v-btn @click="loadMore" :disabled="loading">
      LOAD MORE
      <v-progress-circular
        v-if="loading"
        :size="20"
        indeterminate
        color="primary"
        class="ml-3"
      >
      </v-progress-circular>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "ListNews",
  data() {
    return {
      loading: false
    };
  },
  components: {
    ItemNews: () => import("./ItemNews.vue")
  },
  computed: {
    listNews() {
      return this._.filter(this.$store.getters["news"], function(n) {
        return (
          Date.parse(n.date) < Date.now() && n.display_in_news_list == true
        );
      });
    }
  },
  methods: {
    loadMore() {
      this.loading = true;

      let smallestNewsId = this.listNews.reduce(function(prev, curr) {
        return prev.id < curr.id ? prev : curr;
      });

      const _vm = this;
      this.$store
        .dispatch("getMoreData", {
          endpoint: `/get/news?before_id=${smallestNewsId.id}&limit=10&order_by=id&relations=author,comments`,
          store_as: "news"
        })
        .then(() => {
          _vm.loading = false;
        });
    }
  }
};
</script>
